export var getType = function (obj) { return Object.prototype.toString.call(obj); };
var isType = function (type) { return function (obj) {
    return obj !== undefined && obj !== null && getType(obj) === "[object " + type + "]";
}; };
export var isFn = isType(['Function', 'AsyncFunction', 'GeneratorFunction']);
export var isArr = Array.isArray;
export var isPlainObj = isType('Object');
export var isStr = isType('String');
export var isBool = isType('Boolean');
export var isNum = isType('Number');
export var isObj = function (val) { return typeof val === 'object'; };
export var isRegExp = isType('RegExp');
